import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { DataHealthService, getAuthToken } from '../service';
import { Box, CircularProgress, Stack, Tab, Tabs, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { AbsReactTable, BreadcrumbBar, TABLE } from 'customer_portal-ui-shared';

/** Render Lookup Tab */
const DataLookup = (props) => {
    const { regionLookup, countryLookup, stateLookup, portLookup } = props;

    const [tableColumns, setTableColumns] = useState({ region: [], country: [], state: [], port: [] });
    const [regionData, setRegionData] = useState([]);
    const [countryData, setCountryData] = useState([]);
    const [stateData, setStateData] = useState([]);
    const [portData, setPortData] = useState([]);

    const tempColumns = {
        region: [
            {
                Header: 'Region',
                accessor: 'name'
            },
            {
                Header: 'Location',
                accessor: 'location'
            },
            {
                Header: <center>Regulation</center>,
                accessor: 'count'
            }
        ],
        country: [
            {
                Header: 'Country',
                accessor: 'name'
            },
            {
                Header: 'Location',
                accessor: 'location'
            },
            {
                Header: <center>Regulation</center>,
                accessor: 'count'
            }
        ],
        state: [
            {
                Header: 'State',
                accessor: 'name'
            },
            {
                Header: 'Location',
                accessor: 'location'
            },
            {
                Header: <center>Regulation</center>,
                accessor: 'count'
            }
        ],
        port: [
            {
                Header: 'Port',
                accessor: 'name'
            },
            {
                Header: 'Location',
                accessor: 'location'
            },
            {
                Header: <center>Regulation</center>,
                accessor: 'count'
            }
        ]
    };

    useEffect(() => {
        adjustDataColumns();
    }, []);

    const getCountStyle = (item) => {
        if (item.count <= 0) {
            return {
                backgroundColor: '#EE9C9D',
                borderLeft: '4px solid #DA2528',
                textAlign: 'center'
            };
        }

        return {
            textAlign: 'center'
        };
    };

    /** modify and merge lookup data into two columns */
    const adjustDataColumns = () => {
        if (regionLookup.length) {
            tempColumns.region[0].Header = `Region: ${regionLookup.length}`;
            const tempData = regionLookup.map((item) => {
                return {
                    name: item.name,
                    location: (
                        <div>
                            {item.lat} <br /> {item.lng}
                        </div>
                    ),
                    count: <div style={getCountStyle(item)}>{item.count}</div>
                };
            });

            setRegionData(tempData);
        }

        if (countryLookup.length) {
            tempColumns.country[0].Header = `Country: ${countryLookup.length}`;
            const tempData = countryLookup.map((item) => {
                return {
                    name: (
                        <div>
                            <strong>{item.name}</strong> <br />
                            Region: {item.region}
                        </div>
                    ),
                    location: (
                        <div>
                            {item.lat} <br /> {item.lng}
                        </div>
                    ),
                    count: <div style={getCountStyle(item)}>{item.count}</div>
                };
            });

            setCountryData(tempData);
        }

        if (stateLookup.length) {
            tempColumns.state[0].Header = `State: ${stateLookup.length}`;
            const tempData = stateLookup.map((item) => {
                return {
                    name: (
                        <div>
                            <strong>{item.name}</strong> <br />
                            Country: {item.country} <br />
                            Region: {item.region}
                        </div>
                    ),
                    location: (
                        <div>
                            {item.lat} <br /> {item.lng}
                        </div>
                    ),
                    count: <div style={getCountStyle(item)}>{item.count}</div>
                };
            });

            setStateData(tempData);
        }

        if (portLookup.length) {
            tempColumns.port[0].Header = `Port: ${portLookup.length}`;
            const tempData = portLookup.map((item) => {
                return {
                    name: (
                        <div>
                            <strong>{item.name}</strong> <br />
                            State : {item.state} <br />
                            Country: {item.country} <br />
                            Region: {item.region}
                        </div>
                    ),
                    location: (
                        <div>
                            {item.lat} <br /> {item.lng}
                        </div>
                    ),
                    count: <div style={getCountStyle(item)}>{item.count}</div>
                };
            });

            setPortData(tempData);
        }

        setTableColumns(tempColumns);
    };

    return (
        <>
            <Typography sx={{ marginTop: '10px', marginBottom: '10px' }}>Please contact development team for Lookup data update request.</Typography>
            <Stack direction="row" alignItems="flexStart" justifyContent="space-evenly" spacing={2}>
                <Stack direction="column" spacing={1}>
                    {/* Region */}
                    <AbsReactTable tableType={TABLE.TYPE.BASIC} columns={tableColumns.region} data={regionData} pagination={false} small={true} allowColumnsShowHide={false} />
                </Stack>
                <Stack direction="column" spacing={2}>
                    {/* Country */}
                    <AbsReactTable tableType={TABLE.TYPE.BASIC} columns={tableColumns.country} data={countryData} pagination={false} small={true} allowColumnsShowHide={false} />
                </Stack>
                <Stack direction="column" spacing={2}>
                    {/* State */}
                    <AbsReactTable tableType={TABLE.TYPE.BASIC} columns={tableColumns.state} data={stateData} pagination={false} small={true} allowColumnsShowHide={false} />
                </Stack>
                <Stack direction="column" spacing={2}>
                    {/* Port */}
                    <AbsReactTable tableType={TABLE.TYPE.BASIC} columns={tableColumns.port} data={portData} pagination={false} small={true} allowColumnsShowHide={false} />
                </Stack>
            </Stack>
        </>
    );
};

/** Render Mismatch Data Tab */
const Missmatch = (props) => {
    const { portData, stateData, countryData, regionData } = props;

    const [portTableData, setPortTableData] = useState([]);
    const [stateTableData, setStateTableData] = useState([]);
    const [countryTableData, setCountryTableData] = useState([]);
    const [regionTableData, setRegionData] = useState([]);

    const tableColumns = [
        {
            Header: 'Excel Regulations',
            accessor: 'ExcelFormat'
        },
        {
            Header: 'Lookup Database Table',
            accessor: 'LookupFormat'
        }
    ];

    useEffect(() => {
        loadRegion();
        loadCountry();
        loadState();
        loadPort();
    }, []);

    const loadRegion = () => {
        if (!regionData) {
            return;
        }

        const tableData = regionData.map((data) => {
            data.LookupFormat = (
                <Typography>
                    {data.Potential.map((item) => {
                        return (
                            <>
                                <Typography>Region: {`${item.name || ''}`}</Typography>
                                <br />
                            </>
                        );
                    })}
                </Typography>
            );
            data.ExcelFormat = (
                <>
                    <Typography>Region: {data.Regulation.region}</Typography>
                </>
            );
            return data;
        });

        setRegionData(tableData);
    };

    const loadCountry = () => {
        if (!countryData) {
            return;
        }

        const tableData = countryData.map((data) => {
            data.LookupFormat = (
                <Typography>
                    {data.Potential.map((item) => {
                        return (
                            <>
                                <Typography>Country: {`${item.name || ''}`}</Typography>
                                <Typography>Region: {`${item.region || ''}`}</Typography>
                                <br />
                            </>
                        );
                    })}
                </Typography>
            );
            data.ExcelFormat = (
                <>
                    <Typography>Country: {data.Regulation.country}</Typography>
                    <Typography>Region: {data.Regulation.region}</Typography>
                </>
            );
            return data;
        });

        setCountryTableData(tableData);
    };

    const loadState = () => {
        if (!stateData) {
            return;
        }

        const tableData = stateData.map((data) => {
            data.LookupFormat = (
                <Typography>
                    {data.Potential.map((item) => {
                        return (
                            <>
                                <Typography>State: {`${item.name || ''}`}</Typography>
                                <Typography>Country: {`${item.country || ''}`}</Typography>
                                <Typography>Region: {`${item.region || ''}`}</Typography>
                                <br />
                            </>
                        );
                    })}
                </Typography>
            );
            data.ExcelFormat = (
                <>
                    <Typography>State: {data.Regulation.state}</Typography>
                    <Typography>Country: {data.Regulation.country}</Typography>
                    <Typography>Region: {data.Regulation.region}</Typography>
                </>
            );
            return data;
        });

        setStateTableData(tableData);
    };

    const loadPort = () => {
        if (!portData) {
            return;
        }

        const tableData = portData.map((data) => {
            data.LookupFormat = (
                <Typography>
                    {data.Potential.map((item) => {
                        return (
                            <>
                                <Typography>Port: {`${item.name || ''}`}</Typography>
                                <Typography>State: {`${item.state || ''}`}</Typography>
                                <Typography>Country: {`${item.country || ''}`}</Typography>
                                <Typography>Region: {`${item.region || ''}`}</Typography>
                                <br />
                            </>
                        );
                    })}
                </Typography>
            );
            data.ExcelFormat = (
                <>
                    <Typography>Port: {data.Regulation.port}</Typography>
                    <Typography>State: {data.Regulation.state}</Typography>
                    <Typography>Country: {data.Regulation.country}</Typography>
                    <Typography>Region: {data.Regulation.region}</Typography>
                </>
            );
            return data;
        });

        setPortTableData(tableData);
    };

    return (
        <>
            <Stack direction={'column'} spacing={2} marginTop={'20px'}>
                <Stack direction={'column'} spacing={1}>
                    {regionTableData && regionTableData.length > 0 && (
                        <Typography variant="h5" style={{ color: 'red' }}>
                            Region - {`${regionTableData.length} Issue(s) Found`}{' '}
                        </Typography>
                    )}
                    {regionTableData && regionTableData.length <= 0 && <Typography variant="h5">Region - No Issues Found</Typography>}
                    <AbsReactTable tableType={TABLE.TYPE.BASIC} columns={tableColumns} data={regionTableData} pagination={false} small={true} allowColumnsShowHide={false} />
                </Stack>

                <Stack direction={'column'} spacing={1}>
                    {countryTableData && countryTableData.length > 0 && (
                        <Typography variant="h5" style={{ color: 'red' }}>
                            Country - {`${countryTableData.length} Issue(s) Found`}{' '}
                        </Typography>
                    )}
                    {countryTableData && countryTableData.length <= 0 && <Typography variant="h5">Country - No Issues Found</Typography>}
                    <AbsReactTable tableType={TABLE.TYPE.BASIC} columns={tableColumns} data={countryTableData} pagination={false} small={true} allowColumnsShowHide={false} />
                </Stack>

                <Stack direction={'column'} spacing={1}>
                    {stateTableData && stateTableData.length > 0 && (
                        <Typography variant="h5" style={{ color: 'red' }}>
                            State - {`${stateTableData.length} Issue(s) Found`}{' '}
                        </Typography>
                    )}
                    {stateTableData && stateTableData.length <= 0 && <Typography variant="h5">State - No Issues Found</Typography>}
                    <AbsReactTable tableType={TABLE.TYPE.BASIC} columns={tableColumns} data={stateTableData} pagination={false} small={true} allowColumnsShowHide={false} />
                </Stack>

                <Stack direction={'column'} spacing={1}>
                    {portTableData && portTableData.length > 0 && (
                        <Typography variant="h5" style={{ color: 'red' }}>
                            Port - {`${portTableData.length} Issue(s) Found`}{' '}
                        </Typography>
                    )}
                    {portTableData && portTableData.length <= 0 && <Typography variant="h5">Port - No Issues Found</Typography>}
                    {portTableData && <AbsReactTable tableType={TABLE.TYPE.BASIC} columns={tableColumns} data={portTableData} pagination={false} small={true} allowColumnsShowHide={false} />}
                </Stack>
            </Stack>
        </>
    );
};

/** Structure Page Content with Tabs */
const DataHealth = () => {
    const { instance, accounts } = useMsal();
    const [isLoading, setIsLoading] = useState(true);

    // Table Panel value
    const [tabValue, setValue] = useState(0);

    // Loookup data
    const [regionLookup, setRegionLookup] = useState([]);
    const [countryLookup, setCountryLookup] = useState([]);
    const [stateLookup, setStateLookup] = useState([]);
    const [portLookup, setPortLookup] = useState([]);

    // Missmatch data
    const [missPort, setMissPort] = useState([]);
    const [missState, setMissState] = useState([]);
    const [missCountry, setMissCountry] = useState([]);
    const [missRegion, setMissRegion] = useState([]);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await initMissmatchData();
            await initLookupData();
            setIsLoading(false);
        })();
    }, []);

    /** Get missmatch data from API */
    const initMissmatchData = async () => {
        const authToken = await getAuthToken(instance, accounts);
        const data = await DataHealthService.getMissmatchData(authToken);

        if (!data) {
            return;
        }

        setMissPort(data.Port);
        setMissState(data.State);
        setMissCountry(data.Country);
        setMissRegion(data.Region);
    };

    /** Get lookup data from API */
    const initLookupData = async () => {
        const authToken = await getAuthToken(instance, accounts);
        const lookupData = await DataHealthService.getCountByLookup(authToken);

        if (!lookupData) {
            return;
        }

        // Region
        const arrRegion = lookupData.Region.map((item) => {
            return {
                name: item.Region.name,
                lat: item.Region.lat,
                lng: item.Region.lng,
                count: item.Count
            };
        });

        setRegionLookup(arrRegion.sort((a, b) => a.name.localeCompare(b.name)));

        // Country
        const arrCountry = lookupData.Country.map((item) => {
            return {
                name: item.Country.name,
                region: item.Country.region,
                lat: item.Country.lat,
                lng: item.Country.lng,
                count: item.Count
            };
        });

        setCountryLookup(arrCountry.sort((a, b) => a.name.localeCompare(b.name)));

        // State
        const arrState = lookupData.State.map((item) => {
            return {
                name: item.State.name,
                country: item.State.country,
                region: item.State.region,
                lat: item.State.lat,
                lng: item.State.lng,
                count: item.Count
            };
        });

        setStateLookup(arrState.sort((a, b) => a.name.localeCompare(b.name)));

        // Port
        const arrPort = lookupData.Port.map((item) => {
            return {
                name: item.Port.name,
                state: item.Port.state,
                country: item.Port.country,
                region: item.Port.region,
                lat: item.Port.lat,
                lng: item.Port.lng,
                count: item.Count
            };
        });

        setPortLookup(arrPort.sort((a, b) => a.name.localeCompare(b.name)));
    };

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <BreadcrumbBar
                pageName="Imported Excel Data"
                parentPages={[
                    {
                        name: 'Home',
                        link: '/'
                    }
                ]}
            />
            {isLoading && (
                <Box
                    sx={{
                        textAlign: 'center',
                        marginTop: '132px',
                        minHeight: '700px'
                    }}
                >
                    <CircularProgress />
                </Box>
            )}
            {!isLoading && (
                <>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabValue} onChange={handleTabChange}>
                            <Tab label="Mismatch Data" />
                            <Tab label="Regulation Count" />
                        </Tabs>
                    </Box>
                    <Box sx={{ marginLeft: '20px', marginRight: '20px', marginBottom: '20px' }}>
                        <TabPanel value={tabValue} index={0} data={<Missmatch portData={missPort} stateData={missState} countryData={missCountry} regionData={missRegion} />} />
                        <TabPanel value={tabValue} index={1} data={<DataLookup regionLookup={regionLookup} countryLookup={countryLookup} stateLookup={stateLookup} portLookup={portLookup} />} />
                    </Box>
                </>
            )}
        </>
    );
};

/** This is a helper function to display the correct content when a tab is selected */
const TabPanel = (props) => {
    const { data, value, index } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`}>
            {value === index && <Box>{data}</Box>}
        </div>
    );
};

TabPanel.propTypes = {
    data: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
};

export default DataHealth;
